import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Edit,Delete, TrafficRounded,Done,ControlPointRounded,EditRounded,VisibilityOutlined,GroupWork, Ballot,
  AddOutlined,LocalTaxi,RemoveCircleOutline,EmojiTransportation} from '@material-ui/icons';


import { withLocalize,Translate } from "react-localize-redux";


import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  useMediaQuery,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Chip,
  Grid,
  Slide,
  Divider,Stepper,Step,StepLabel
} from "@material-ui/core";

import MUIDataTable from "mui-datatables";
import API from './api';
import { useSnackbar } from 'notistack';

// import * as userInfo from "./login_info.js";

import UserInfo from "./login_info";



import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import FormGroup from '@material-ui/core/FormGroup';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';




import axios from 'axios';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {TransportService} from "./../../utils/web_config_2";
import CloseIcon from '@material-ui/icons/Close';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  chip: {
    margin: theme.spacing(0.5),
  },
  formTitle:{
    flexGrow:1,
},
branches:{
    backgroundColor: theme.palette.background.paper,
},appBar: {
  position: 'relative',
},
title: {
  marginLeft: theme.spacing(2),
  flex: 1,
},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


 function Outlets() {
  const Theme = useTheme();
  const classes = useStyles1();
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));

  const [outletMessage,setOutletMessage]=useState("Loading");

  const [operatorData, setOperatorData] = useState({});

  const [outtletTitle,setOutletTitle]=useState("All Outlets");

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();


  const [branchMessage,setBranchMessage]=useState("Loading branch...");
  

  // new branch dialog 

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
///  menu action

const [anchorEl, setAnchorEl] = useState(null);
const openMenu = Boolean(anchorEl);

const handleClickMenu = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleCloseMenu = () => {
  setAnchorEl(null);
};


// new outlet dialog 

const [openOutlet, setOpenOutlet] = useState(false);

const handleClickOpenOutlet = () => {
  setOpenOutlet(true);
};

const handleCloseOutlet = () => {
  setOpenOutlet(false);
};


// branches table 
const columns = [
  {
    name: "id",
    label: "id",
    options: {
      display:false,
     filter: true,
     sort: true,
    }
   },
  {
    name: "name",
    label: "Name",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "manager_names",
   label:"Branch Manager",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
    name: "description",
    label: "Description",
    options: {
     filter: true,
     sort: false,
    }
   },
  {
    name: "status",
    label: "Status",
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
      return (
        <Chip
        color="primary"
        variant="outlined"
        label={value}
        icon={<Done/>}
      ></Chip>
          
      );
    }
    }
   }
 ];
 
// outlets table 

const columnsOutlets = [
  {
    name: "id",
    label: "id",
    options: {
      display:false,
     filter: true,
     sort: true,
    }
   },
  {
    name: "name",
    label: "Name",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "code",
   label:"Code",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
    name: "description",
    label: "Description",
    options: {
     filter: true,
     sort: false,
    }
   },
  // {
  //   name: "status",
  //   label: "Status",
  //   options: {
  //    filter: true,
  //    sort: false,
  //    customBodyRender: (value, tableMeta, updateValue) => {
  //     return (
  //       <Chip
  //       color="primary"
  //       label={value}
  //       icon={<Done/>}
  //     ></Chip>
          
  //     );
  //   }
  //   }
  //  }
 ];

//  outlet options 

 
const optionsOutlet = {
  textLabels: {
    body: {
      noMatch: outletMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:"single",
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    
<Box display="flexs">

<Chip
        label="Modify outlet"
        onClick={()=>{

          var id=displayData[selectedRows.data[0]['index']]['data'][0];

          console.log("id",id);

          var obj=outlets.find((item,i) => {
            return item.id == id;
        });
       console.log(obj.location_id);
setOutletId({value:obj.id,error:""});
setOCode({value:obj.code,error:""});
setCoordinates({value:obj.coordinates,error:""});
setODescription({value:obj.description,error:""});
setLocation({value:obj.location_id,error:""});
setOutletName({value:obj.name,error:""});
setOutletModify(true);    
        }}
        onDelete={()=>{

          var id=displayData[selectedRows.data[0]['index']]['data'][0];

          var obj=outlets.find((item,i) => {
            return item.id == id;
        });
       console.log(obj.location_id);
setOutletId({value:obj.id,error:""});
setOCode({value:obj.code,error:""});
setCoordinates({value:obj.coordinate,error:""});
setODescription({value:obj.description,error:""});
setLocation({value:obj.location_id,error:""});
setOutletName({value:obj.name,error:""});
setOutletModify(true);    
        }}
        deleteIcon={<Edit/>}
        variant="outlined"
        className={classes.chip}
/> 



<Chip
        label="Add route in outlet"
        onClick={()=>{

         
       var id=displayData[selectedRows.data[0]['index']]['data'][0];

setOutletId({value:id,error:""});
setAssignDialog(true);

        }}
        onDelete={()=>{

               
       var id=displayData[selectedRows.data[0]['index']]['data'][0];

       setOutletId({value:id,error:""});
       setAssignDialog(true);
       

        }}
        deleteIcon={<LocalTaxi/>}
        variant="outlined"
        className={classes.chip}
/> 


<Chip
        label="View Route"
        onClick={()=>{

          var id=displayData[selectedRows.data[0]['index']]['data'][0];
          get_route_outlet(id);
        }}
        onDelete={()=>{

          var id=displayData[selectedRows.data[0]['index']]['data'][0];
          get_route_outlet(id);
        }}
        deleteIcon={<EmojiTransportation/>}
        variant="outlined"
        className={classes.chip}
/> 




      </Box>
  ),
 };


 // tabel options
 
 const options = {
  textLabels: {
    body: {
      noMatch: branchMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:"single",
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    
<Box display="flexs">

<Chip className={classes.chip} avatar={<Edit />} variant="outlined" label="Edit" onClick={()=>{
var id=displayData[selectedRows.data[0]['index']]['data'][0];
// console.log("id");
console.log(id);
var obj=branches.find((o)=>o.id==id);


setName({value:obj['name'],error:""});
setBranchmanager({value:obj['branch_manager']!=null?obj['branch_manager']['id']:1,error:""});
setDescription({value:obj['description'],error:""});
setBranchId({value:id,error:""});
setBranchDialog(true);
}} />

<Chip className={classes.chip} avatar={<Ballot/>} variant="outlined" label="Outlets" onClick={()=>{
var id=displayData[selectedRows.data[0]['index']]['data'][0];
var obj=branches.find((o)=>o.id==id);

console.log("branch id"+id);

setOutlets([]);
setOutletTitle(obj['name']+" Outlets");
setBranchId({value:id,error:""});

get_outlet_by_branch(obj['id']);

}} />                
      </Box>
  ),
 };



 useEffect(()=>{

  var data = {};
  const data1 = localStorage.getItem("nx_op");
  if (data1 != null) {
    data = JSON.parse(data1);
  }
  setOperatorData(data);
  axios.defaults.baseURL = new TransportService().BASE_URL;
  get_users(data.token);
  getProvinces(data.token);
  getDistricts(data.token);
  getBranches(data.token);
  get_all_outlet(data.token);
  getRoutes(data.token);

 },[]);

 // get branches
 const [loadBranches,setLoadbranches]=useState(false);
 const [branches,setBranches]=useState([]);
 const getBranches=(token)=>{

  const branchInstance = axios.create(new TransportService().setHeaders(token));
   setLoadbranches(true);
   branchInstance.get("/api/v1/branching/getBranchsByOrganization/"+new UserInfo().ID)
   .then(res=>{
    setLoadbranches(false);
     if(res.status==200){ 
      var d=res.data;

      if(d.length==0){
        setBranchMessage("No branches available");
      }
      Object.keys(d).map(
        function(o){
          d[o]["manager_names"]=d[o].branch_manager!=null?d[o].branch_manager.names:"Null";
      });
      setBranches(d);

     }
   }).catch(err => {
    setLoadbranches(false);
    console.log(err);
    if(err.message){
      enqueueSnackbar(err.message,
        { 
          variant: 'error'
      });
    }

    if(err.response){
      enqueueSnackbar(err.response.data.message,
        { 
          variant: 'error'
      });

    }
});




 }


 // add new branch
 const [branchStatus,setBranchstatus]=useState({load:false,status:false});
 const [name,setName]=useState({value:"",error:""});
 const [branchManager,setBranchmanager]=useState({value:"",error:""});
 const [description,setDescription]=useState({value:"",error:""});

 const addBranch=()=>{
   if(name.value===""){
     setName({value:"",error:"Enter branch name"});
   }else if(branchManager.value===""){
     setBranchmanager({value:"",error:"Select branch manager"});
   }else if(description.value===""){
     setDescription({value:"",error:"Enter description"});
   }else{
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const branchInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    setBranchstatus({load:true,status:false});
    branchInstance.post("/api/v1/branching/addBranch",{
      "branch_manager_id": branchManager.value,
      "description": description.value,
      "name": name.value,
      "organization_id": new UserInfo().ORG_ID
    }
     ).then(res=>{
      
       if(res.status==201){
        enqueueSnackbar('Branch added successful!', { 
          variant: 'success',
      });
        setOpen(false);
        setBranchstatus({load:false,status:TrafficRounded});
        getBranches(operatorData.token);
       }
       console.log(res);
       console.log(res.data);
     }).catch(err=>{
      enqueueSnackbar(err.message, { 
        variant: 'error',
    });
     });
   }
 }

 // edit branch dialog

 const [branchDialog,setBranchDialog]=useState(false);

 /// edit branch 
 const [editLoad,setEditLoad]=useState(false);
 const [branchId,setBranchId]=useState({value:0,error:""});
 const editBranch=()=>{
  
  if(name.value===""){
    setName({value:"",error:"Enter branch name"});
  }else if(branchManager.value===""){
    setBranchmanager({value:"",error:"Select branch manager"});
  }else if(description.value===""){
    setDescription({value:"",error:"Enter description"});
  }else{
    setEditLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const branchInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    branchInstance.put("/api/v1/branching/modifyBranch",
    {
      "branch_manager_id": branchManager.value,
      "description": description.value,
      "id": branchId.value,
      "name": name.value
    }
    ).then(res=>{
      setEditLoad(false);
      setBranchDialog(false);
      enqueueSnackbar('Branch edited successful!', { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });

    getBranches(operatorData.token);

    }).catch(err=>{
      setEditLoad(false);
      enqueueSnackbar(err.message, { 
        variant: 'error',
    });
    });


  }
 }



 

 /// view all outlets
 
const [outletLoad,setOutletLoad]=useState(false);
const [outlets,setOutlets]=useState([]);
const get_all_outlet=(token)=>{
  setOutletMessage("Loading...");
  setOutletLoad(true);
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const outletInstance = axios.create(new TransportService().setHeaders(token));
 
  outletInstance.get("/api/v1/branching/getOutlets")
  .then(res=>{

      //  const data=[];
       let d=res.data;
      //  d.map((dd)=>{
      //   var obj={id:dd['id'],code:dd['code'],name:dd['name'],description:dd['description'],location:dd['location']!=null?dd['location']['name']:"No location",coordinate:dd['coordinates'],location_id:dd['location']!=null?dd['location']['id']:null};
      //   data.push(obj);
      //  });

      setOutlets(d);
      setOutletLoad(false);

      if(d.length==0){
        setOutletMessage("No outlet available");
      }
  })
  .catch(err=>{
    setOutletLoad(false);
    enqueueSnackbar(err.message, { 
      variant: 'error',
  });
  });
}



// =========================================================


// view specific branch's outlets 


const get_outlet_by_branch=(id)=>{
  
  setOutletDialog(true);

  setOutletLoad(true);
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const outletInstance = axios.create(new TransportService().setHeaders(operatorData.token));
  outletInstance.get('/api/v1/branching/getOutletsByBranch/'+id)
  .then(res=>{

      //  const data=[];
       let d=res.data;
      //  d.map((dd)=>{
      //   var obj={id:dd['id'],code:dd['code'],name:dd['name'],description:dd['description'],location:dd['location']!=null?dd['location']['name']:"No location",coordinate:dd['coordinates'],location_id:dd['location']!=null?dd['location']['id']:null};
      //   data.push(obj);
      //  });
      console.log("=======outlet=========");
      console.log(d);
      setOutlets(d);
      setOutletLoad(false);

      if(d.length==0){
        setOutletMessage("No outlet available");
      }
  })
  .catch(err=>{
    setOutletLoad(false);
    enqueueSnackbar(err.message, { 
      variant: 'error',
  });
  });




  // // ===============================================================
  // let filter_outlets=branches.filter((b)=>b.id==id);
  // if(filter_outlets[0]['outlets'].length!=0){
  //   let data=filter_outlets[0]['outlets'];
  //   data.map(()=>{

  //   })

  //   const data1=[];
  //   let d=data;
  //   d.map((dd)=>{
  //    var obj={id:dd['id'],code:dd['code'],name:dd['name'],description:dd['description'],location:dd['location']!=null?dd['location']['name']:"No location",coordinate:dd['coordinates'],location_id:dd['location']!=null?dd['location']['id']:null};
  //    data1.push(obj);
  //   });


  //   setOutlets(data1);

  //   console.log(filter_outlets);


  // }else{
  //   enqueueSnackbar('No outlets available!', { 
  //     variant: 'warnning',
  //     anchorOrigin: {
  //       vertical: 'bottom',
  //       horizontal: 'right',
  //   },
  // });

  // }
  
}

// ==========================================================





/// add outlet in a branch  dailog

const [outlet_id,setOutlet_id]=useState(0);

const [addOutletLoad,setAddOutletLoad]=useState(false);
const [addOutletDialog,setAddOutletDialog]=useState(false);
const [oCode,setOCode]=useState({value:"",error:""});
const [coordinates,setCoordinates]=useState({value:"",error:""});
const [odescription,setODescription]=useState({value:"",error:""});
const [location,setLocation]=useState({value:0,error:""});
const [outletName,setOutletName]=useState({value:"",error:""});
const addOutlet=()=>{
  if(oCode.value==""){
    setOCode({value:"",error:"Enter code"});
  }else if(coordinates.value==""){
    setCoordinates({value:"",error:"Enter coordinates"});
  }else if(odescription.value==""){
    setODescription({value:"",error:"Enter description"});
  }else if(outletName.value==""){
    setOutletName({value:"",error:"Enter name"});
  }else if(location.value==""){
    setLocation({value:"",error:""});
  }else{
    setAddOutletLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const outletInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    outletInstance.post("/api/v1/branching/addAoutlet",
    {
      "branch_id": branchId.value,
      "code": oCode.value,
      "coordinates": coordinates.value,
      "description": odescription.value,
      "location_id": location.value,
      "name": outletName.value
    }
    ).then(res=>{
      // get_all_outlet(operatorData.token);
      var obj=res.data;
      var a=outlets;
      a.unshift(obj);
      setOutlets(a);
      console.log("outlet obj",obj);
      console.log("outlet id",obj.id);
      setOutlet_id(obj.id);


    
      setAddOutletLoad(false);
      setAddOutletDialog(false);
      enqueueSnackbar('Outlet inserted well!', { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });

    handleNext();

    }).catch(err=>{
      setAddOutletLoad(false);
      enqueueSnackbar(err.message, { 
        variant: 'error',
    });
    }); 
  }
  

}




// add outlet in branch in steps with routes 


const [dialogStep,setDialogStep]=useState(false);

const [activeStep, setActiveStep] =useState(0);
  const steps = ['Add Outlet', 'Add routes'];

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };



  const [assignRoutesLoad,setAssignRoutesLoad]=useState(false);
  const [routesOutlet,setRoutesOutlet]=useState([]);
  const assign_routes=()=>{
    
    if(routesOutlet.length==0){
      enqueueSnackbar('Add atleast one route!', { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    }else{

      setAssignRoutesLoad(true);
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const routesOutletInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      routesOutletInstance.put('/api/v1/branching/addRoutesToOutlet',
      {
        "outlet_id": outlet_id,
        "route_ids": routesOutlet+""
      })
      .then(res=>{
        setDialogStep(false);
        setAssignRoutesLoad(false);
        setActiveStep(0);
        enqueueSnackbar('Routes assigned successful!', { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      })
      .catch(err=>{
        setDialogStep(false);
        setAssignRoutesLoad(false);
        if(err.message){


          enqueueSnackbar(err.message, { 
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });

        if(err.response){
if(err.response.status==400){
            enqueueSnackbar(err.response.data.message, { 
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            },
          });
          }
        } 
        }
      });
    }

  }




  // get province

  const [provinceId,setProvinceId]=useState({value:"",error:""});
  const [provinces,setProvinces]=useState([]);
  const getProvinces=(token)=>{
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const provinceInstance = axios.create(new TransportService().setHeaders(token));
    provinceInstance.get("/api/v1/locations/findLocationsByLevel/2").then(res=>{
    if(res.status==200){
      setProvinces(res.data);
    }
  }).catch(err=>{
    if(err.message){
      enqueueSnackbar(err.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    }
  })
  }


  // get district

const [districts,setDistricts]=useState([]);
const getDistricts=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const districtInstance = axios.create(new TransportService().setHeaders(token));
  districtInstance.get("/api/v1/locations/findLocationsByLevel/3"
  ).then(res=>{
    if(res.status==200){
      setDistricts(res.data);
    }
  }) 
}

// filter district 

const [filterDistrict,setFilterDistrict]=useState([]);
const FilterDistrict=(id)=>{
setFilterDistrict(districts.filter((d)=>d['parent']['id']==id));
}

// modify outlet dialog
const [outletModify,setOutletModify]=useState(false);

// modify outlet dialog

const [outletId,setOutletId]=useState({value:0,error:""});
const [modifyLoad,setModifyLoad]=useState(false);
const modify_outlet=()=>{
  if(oCode.value==""){
    setOCode({value:"",error:"Enter code"});
  }else if(coordinates.value==""){
    setCoordinates({value:"",error:"Enter coordinates"});
  }else if(odescription.value==""){
    setODescription({value:"",error:"Enter description"});
  }else if(outletName.value==""){
    setOutletName({value:"",error:"Enter name"});
  }else if(location.value==""){
    setLocation({value:"",error:""});
  }else{
    setModifyLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const outletInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    outletInstance.put("/api/v1/branching/modifyOutlet",
    {
      "branch_id": branchId.value,
      "code": oCode.value,
      "coordinates": coordinates.value,
      "description": odescription.value,
      "location_id": location.value,
      "name": outletName.value,
      "id":outletId.value
    }
    ).then(res=>{
      setModifyLoad(false);
      setOutletModify(false);
      get_outlet_by_branch(branchId.value);
     
      enqueueSnackbar('Outlet updated well!', { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    }).catch(err=>{
      setModifyLoad(false);
      console.log(err);
    }); 
  }
  
}



/// get routes 
const [routes,setRoutes]=useState([]);
const getRoutes=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const routesInstance = axios.create(new TransportService().setHeaders(token));
  routesInstance.get("/api/v1/integrations/getRoutesByOrganization/"+new UserInfo().ORG_ID,{
   }).then(res=>{
     console.log(res);
     console.log(res.data);
     var objs=res.data;
     var n_objs=objs.filter((o)=>o.status!="CANCELED");
     setRoutes(n_objs);
   }).catch(err=>{
     console.log(err);
   })
 }


 /// get route in outlet

 const [routeOutletDialog,setRouteOutletDialog]=useState(false);
 const [routeOutletLoad,setRouteOutleLoad]=useState(false);
 const [routeOutlet,setRouteOutle]=useState([]);
 const get_route_outlet=(id)=>{
  setRouteOutleLoad(true);
  setRouteOutletDialog(true);
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const routeoutletInstance = axios.create(new TransportService().setHeaders(operatorData.token));
  routeoutletInstance.get('/api/v1/branching/geRoutesByOutletI/'+id)
  .then(res=>{
    var objs=res.data;

    var r=[];

    objs.map((o)=>{
      if(o.status!="CANCELED"){
        r.push(o);
      }
    });
  
    console.log("route outlet ",objs);

    if(r!=0){
      setRouteOutle(r);
    }

    setRouteOutleLoad(false);

  })
  .catch(err=>{
    setRouteOutleLoad(false);
    if(err.message){
      enqueueSnackbar(err.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    }


    if(err.response){
      enqueueSnackbar(err.response.data.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    }


  });
 }


// assign route to outlet dialog
const [assignDialog,setAssignDialog]=useState(false);

// assign route ro outlet
const [routeId,setRouteId]=useState({value:0,error:""});
const [assignLoad,setAssignLoad]=useState(false);
const assign_route=()=>{
  if(routeId.value==0){
    setRouteId({value:0,error:"Choose route"});
  }else{
    setAssignLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const assignInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    assignInstance.put('/api/v1/branching/addOutletToRoute',
      {
        "outlet_id": outletId.value,
        "route_id": routeId.value
      }
    ).then(res=>{
      setAssignLoad(false);
      setAssignDialog(false);
      enqueueSnackbar('Route added to outlet successful!', { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    }); 
    }).catch(error=>{
      setAssignLoad(false);
      console.log(error);
      if(error.response){
        enqueueSnackbar(error.response.data.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      }); 
      }
    });

  }
  
}
 
// branch outlet dialog 

const [outletDialog,setOutletDialog]=useState(false);


// get users

const [users,setUsers]=useState([]);
const get_users=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const usersInstance = axios.create(new TransportService().setHeaders(token));
  usersInstance.get('/api/v1/integrations/getUsersByOrganization/'+new UserInfo().ORG_ID)
  .then(res=>{
    setUsers(res.data);
  }).catch(err=>{
    if(err.message){
      enqueueSnackbar(err.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    }
  });
}


  return (

<div className={classes.root}>

<Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><AllInclusive fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b><Translate id="operator_branch.branch_outlet"/></b></Typography>

 </Box>
 
<Button  
className={classes.btn}
size="small"
startIcon={<Add/>} 
onClick={()=>{handleClickOpen()}} 
variant="contained" 
color="primary"
disableElevation={true}>

{matches&&<Typography noWrap> <Translate id="operator_branch.new_branch"/></Typography>}
</Button>
 

</Box>

<Grid container >

  {/* <Grid md={4} lg={4} xs={12} sm={4}>
 
 <Box mt={1} mr={1} className={classes.branches}>
   <Box display="flex"><Box ml={2} display="flex" style={{flexGrow:1}}><Typography variant="h6">List of Branches</Typography></Box> 
   <Chip
        label="add Branch"
        onClick={()=>{handleClickOpen()}} 
        onDelete={()=>{handleClickOpen()}}
        deleteIcon={<ControlPointRounded/>}
        variant="outlined"
        color="primary"
        className={classes.chip}
/> </Box>
 {loadBranches&&<LinearProgress />}
            <List dense={true}>
              {branches.map((b)=>{
                return  <ListItem>
                <ListItemAvatar>
                    <GroupWork/>
                </ListItemAvatar>
                <ListItemText
                  primary={b['name']}
                  secondary={b['branch_manager']!=null?b['branch_manager']['names']:"No manager"}
                />
                <ListItemSecondaryAction>
                  <IconButton onClick={()=>{
                    console.log(b['id']);
                    setName({value:b['name'],error:""});
                    setBranchmanager({value:b['branch_manager']!=null?b['branch_manager']['id']:1,error:""});
                    setDescription({value:b['description'],error:""});
                    setBranchId({value:b['id'],error:""});
                    setBranchDialog(true);

                  }} edge="end" aria-label="delete">
                    <Edit />
                  </IconButton>

                  <IconButton onClick={()=>{
                    setBranchId({value:b['id'],error:""});
                    setAddOutletDialog(true);
                  }} edge="end" aria-label="Add outlet">
                    <AddOutlined/>
                  </IconButton>

                  <IconButton onClick={()=>{
                    if(b['outlets'].length!=0){
                      setOutletTitle(b['name']+" Outlets");
                    }
                   
                    setBranchId({value:b['id'],error:""});
                    get_outlet_by_branch(b['id']);


// ==========================================

setOutletDialog(true);


                  }} edge="end" aria-label="view outlets">
                    <VisibilityOutlined/>
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>;
              })}
            </List>
          </Box>

  </Grid>
   */}
  
  <Grid md={12} lg={12} xs={12} sm={12}>
  <Box mt={1}>
 {loadBranches&&<LinearProgress />}
 <MUIDataTable
  title={"List of Branches"}
  data={branches}
  columns={columns}
  options={options}
/>

 </Box>
  </Grid>
</Grid>

 

{/* dialog new branch  */}

    <Dialog
    maxWidth="sm"
    fullWidth
        open={open}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle id="new branch"><Translate id="operator_branch.new_branch" /></DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
              <Box display='flex' alignItems='center' justifyContent='center'>
               <TextField size='small' variant='outlined' label={<Translate id="operator_branch.form_new_branch.branch_name"/>} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setName({value:"",error:"Enter branch name"})
                 }else{
                   setName({value:e.target.value,error:""});
                 }
               }} 
               error={name.error!==""}
               helperText={name.error}/>
              </Box>

              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
      
                 <InputLabel htmlFor="manager"><Translate id="operator_branch.form_new_branch.choose_manager" /></InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select manager"
        inputProps={{
          name: 'manager',
          id: 'manager',
        }}
        onChange={(e)=>{
          if(e.target.value===""){
            setBranchmanager({value:"",error:"Enter branch name"});
          }else{
            setBranchmanager({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {users.map((u)=>{
            if(u.user_type=="ORG_USER"){
              return  <MenuItem value={u['id']}>{u['names']}</MenuItem>
            }else{
              return null;
            }
           
          })}
        </Select>
      <FormHelperText error={branchManager.error!==""}>{branchManager.error}</FormHelperText>
      </FormControl>
</Box>
<Box mt={1}>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

<TextField  size="small" rowsMax={10} rows={10} variant='outlined' label={<Translate id="operator_route.from_new_route.description" />}   color='primary'  fullWidth multiline 
onChange={(e)=>{
if(e.target.value===""){
  setDescription({value:"",error:"Enter description"});
}else{
  setDescription({value:e.target.value,error:""});
}
}}
/>
 </FormControl>
</Box>
                  
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined"  className={classes.btn}>
          <Typography><Translate id="operator_branch.form_new_branch.cancel" /></Typography>
          </Button>
          <Button disableElevation onClick={addBranch} variant="contained" color="primary" className={classes.btn} autoFocus>
            {branchStatus.load?<CircularProgress size={20} color="secondary" />:<Typography><Translate id="operator_branch.form_new_branch.save" /></Typography>}
            
          </Button>
        </DialogActions>
      </Dialog>

{/* edit branch  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={branchDialog}
       
        aria-labelledby="edit_branch"
        aria-describedby="edit_branch"
      >
        <DialogTitle id="edit_branch">Edit Branch</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
              <Box display='flex' alignItems='center' justifyContent='center'>
               <TextField value={name.value} size='small' variant='outlined' label={<Translate id="operator_branch.form_new_branch.branch_name"/>} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setName({value:"",error:"Enter branch name"})
                 }else{
                   setName({value:e.target.value,error:""});
                 }
               }} 
               error={name.error!==""}
               helperText={name.error}/>
              </Box>

              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
      
                 <InputLabel htmlFor="manager"><Translate id="operator_branch.form_new_branch.choose_manager" /></InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select manager"
        inputProps={{
          name: 'manager',
          id: 'manager',
        }}
        onChange={(e)=>{
          if(e.target.value===""){
            setBranchmanager({value:"",error:"Enter branch name"});
          }else{
            setBranchmanager({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {users.map((u)=>{
            if(u.user_type=="ORG_USER"){
              return  <MenuItem value={u['id']}>{u['names']}</MenuItem>
            }else{
              return null;
            }
           
          })}
        </Select>
      <FormHelperText error={branchManager.error!==""}>{branchManager.error}</FormHelperText>
      </FormControl>
</Box>
<Box mt={1}>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

<TextField value={description.value}  size="small" rowsMax={10} rows={10} variant='outlined' label={<Translate id="operator_route.from_new_route.description" />}   color='primary'  fullWidth multiline 
onChange={(e)=>{
if(e.target.value===""){
  setDescription({value:"",error:"Enter description"});
}else{
  setDescription({value:e.target.value,error:""});
}
}}
/>
 </FormControl>
</Box>
                  
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
            setBranchDialog(false);
          }} color="secondary" variant="outlined"  className={classes.btn}>
          <Typography><Translate id="operator_branch.form_new_branch.cancel" /></Typography>
          </Button>
          <Button disableElevation onClick={()=>{
            editBranch();
          }} variant="contained" color="primary" className={classes.btn} autoFocus>
            {editLoad?<CircularProgress size={20} color="secondary" />:<Typography><Translate id="operator_branch.form_new_branch.save" /></Typography>}
            
          </Button>
        </DialogActions>
      </Dialog>






{/* dialog add outlets  */}


<Dialog
    maxWidth="sm"
    fullWidth
        open={addOutletDialog}
       
        aria-labelledby="edit_branch"
        aria-describedby="edit_branch"
      >
        <DialogTitle id="edit_branch">Add Outlet</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
             
               
  
              <Box display='flex' alignItems='center' justifyContent='center'>
               <TextField  size='small' variant='outlined' label={"Code"} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setOCode({value:"",error:"Enter code"})
                 }else{
                   setOCode({value:e.target.value,error:""});
                 }
               }} 
               error={oCode.error!==""}
               helperText={oCode.error}/>
              </Box>

              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
               <TextField  size='small' variant='outlined' label={"Name"} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setOutletName({value:"",error:"Enter name"})
                 }else{
                   setOutletName({value:e.target.value,error:""});
                 }
               }} 
               error={outletName.error!==""}
               helperText={outletName.error}/>
              </Box>




              <Box mt={1}  display='flex' alignItems='center' justifyContent='center'>
               <TextField  size='small' variant='outlined' label={"Coordinates"} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setCoordinates({value:"",error:"Enter coordinates"})
                 }else{
                   setCoordinates({value:e.target.value,error:""});
                 }
               }} 
               error={coordinates.error!==""}
               helperText={coordinates.error}/>
              </Box>

              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="location">Select province</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select level"
        inputProps={{
          name: 'level',
          id: 'level',
        }}
        error={provinceId.error!==""}
        onChange={(e)=>{
          if(e.target.value===""){
            setProvinceId({value:"",error:"Select province"});
          }else{
            setProvinceId({value:e.target.value,error:""});
            FilterDistrict(e.target.value);
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {
            provinces.map((p)=>{
            return <MenuItem value={p['id']}>{p['name']}</MenuItem>
            })
          }
        </Select>
        <FormHelperText error={provinceId.error!==""}>{provinceId.error}</FormHelperText>
      </FormControl>
</Box>




<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="district">Choose district</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select district"
        inputProps={{
          name: 'disctrict',
          id: 'district',
        }}

        error={location.error!==""}
        onChange={(e)=>{
          if(e.target.value===""){
            setLocation({value:0,error:"Select district"});
          }else{
            setLocation({value:e.target.value,error:""});
            console.log(e.target.value);
          }
        }}
        
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          { 
            filterDistrict.map((d)=>{
                return <MenuItem value={d['id']}>{d['name']}</MenuItem>;
              }
            )
          }
        </Select>
        <FormControl error={location.error!==""}>{location.error}</FormControl>
      </FormControl>


</Box>





<Box mt={1}>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

<TextField   size="small" rowsMax={10} rows={10} variant='outlined' label={<Translate id="operator_route.from_new_route.description" />}   color='primary'  fullWidth multiline 
onChange={(e)=>{
if(e.target.value===""){
  setODescription({value:"",error:"Enter description"});
}else{
  setODescription({value:e.target.value,error:""});
}
}}
/>
 </FormControl>
</Box>
                  
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
             setAddOutletDialog(false);
          }} color="secondary" variant="outlined"  className={classes.btn}>
          <Typography><Translate id="operator_branch.form_new_branch.cancel" /></Typography>
          </Button>
          <Button disabled={addOutletLoad} disableElevation onClick={()=>{
            addOutlet();
          }} variant="contained" color="primary" className={classes.btn} autoFocus>
            {addOutletLoad?<CircularProgress size={20} color="secondary" />:<Typography><Translate id="operator_branch.form_new_branch.save" /></Typography>}
            
          </Button>
        </DialogActions>
      </Dialog>


 {/* dialog add outlet in steps  */}



 <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={dialogStep}
       
        aria-labelledby="new_outlets"
        aria-describedby="new_outlet"
      >
        <DialogTitle id="new_outlet">Add New Outlet</DialogTitle>
        <DialogContent>
          <DialogContentText >
        


          <Stepper activeStep={activeStep} alternativeLabel>


        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}


      </Stepper>
      <Box>
        {activeStep === steps.length ? (
          <Box>
            <Typography >All steps completed</Typography>
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        ) : (
          <Box>
            <Typography >
              
              
              {/* {getStepContent(activeStep)} */}
              {
                activeStep==0&&
                <Box>
             
               
  
                <Box display='flex' alignItems='center' justifyContent='center'>
                 <TextField  size='small' variant='outlined' label={"Code"} fullWidth
                 onChange={(e)=>{
                   if(e.target.value===""){
                     setOCode({value:"",error:"Enter code"})
                   }else{
                     setOCode({value:e.target.value,error:""});
                   }
                 }} 
                 error={oCode.error!==""}
                 helperText={oCode.error}/>
                </Box>
  
                <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                 <TextField  size='small' variant='outlined' label={"Name"} fullWidth
                 onChange={(e)=>{
                   if(e.target.value===""){
                     setOutletName({value:"",error:"Enter name"})
                   }else{
                     setOutletName({value:e.target.value,error:""});
                   }
                 }} 
                 error={outletName.error!==""}
                 helperText={outletName.error}/>
                </Box>
  
  
  
  
                <Box mt={1}  display='flex' alignItems='center' justifyContent='center'>
                 <TextField  size='small' variant='outlined' label={"Coordinates"} fullWidth
                 onChange={(e)=>{
                   if(e.target.value===""){
                     setCoordinates({value:"",error:"Enter coordinates"})
                   }else{
                     setCoordinates({value:e.target.value,error:""});
                   }
                 }} 
                 error={coordinates.error!==""}
                 helperText={coordinates.error}/>
                </Box>
  
                <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
  <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                   <InputLabel htmlFor="location">Select province</InputLabel>
          <Select
          size="small"
          helperText={"error"} 
          label="Select level"
          inputProps={{
            name: 'level',
            id: 'level',
          }}
          error={provinceId.error!==""}
          onChange={(e)=>{
            if(e.target.value===""){
              setProvinceId({value:"",error:"Select province"});
            }else{
              setProvinceId({value:e.target.value,error:""});
              FilterDistrict(e.target.value);
            }
          }}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {
              provinces.map((p)=>{
              return <MenuItem value={p['id']}>{p['name']}</MenuItem>
              })
            }
          </Select>
          <FormHelperText error={provinceId.error!==""}>{provinceId.error}</FormHelperText>
        </FormControl>
  </Box>
  
  
  
  
  <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
  <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                   <InputLabel htmlFor="district">Choose district</InputLabel>
          <Select
          size="small"
          helperText={"error"} 
          label="Select district"
          inputProps={{
            name: 'disctrict',
            id: 'district',
          }}
  
          error={location.error!==""}
          onChange={(e)=>{
            if(e.target.value===""){
              setLocation({value:0,error:"Select district"});
            }else{
              setLocation({value:e.target.value,error:""});
              console.log(e.target.value);
            }
          }}
          
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            { 
              filterDistrict.map((d)=>{
                  return <MenuItem value={d['id']}>{d['name']}</MenuItem>;
                }
              )
            }
          </Select>
          <FormControl error={location.error!==""}>{location.error}</FormControl>
        </FormControl>
  
  
  </Box>
  
  
  
  
  
  <Box mt={1}>
  <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  
  
  <TextField   size="small" rowsMax={10} rows={10} variant='outlined' label={<Translate id="operator_route.from_new_route.description" />}   color='primary'  fullWidth multiline 
  onChange={(e)=>{
  if(e.target.value===""){
    setODescription({value:"",error:"Enter description"});
  }else{
    setODescription({value:e.target.value,error:""});
  }
  }}
  />
   </FormControl>
  </Box>
                    
              
          </Box>
          
   
   }
              {
                activeStep==1&&
                <Box>

                <Autocomplete
        multiple
        id="routes"
        options={routes}
        getOptionLabel={(option) => option.name}
        // defaultValue={[top100Films[13]]}
       

        // value={value}
        onChange={(event, newValue) => {
          if(newValue!=null);{
            console.log("new value",newValue);
            var ids=[];
            newValue.map((n)=>{
              ids.push(n['id']);
            });
            console.log(ids);
            setRoutesOutlet(ids);
          }
          
        }}

       
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select routes"
            placeholder="Routes"
          />
        )}
      />

              </Box>

              }
              
              </Typography>

            <Box mt={2}>
              <Button
                disabled={activeStep === 0}
                onClick={handleBack}
                
              >
                Back
              </Button>
              <Button variant="contained" color="primary"
              
              onClick={()=>{
                console.log("step",activeStep);
                if(activeStep === 1){
                  assign_routes();
                }else{
                  addOutlet();
                }
                 }
                 }>
                {activeStep === steps.length - 1 ?assignRoutesLoad?<CircularProgress size={25} color="secondary"/>:'Save':addOutletLoad?<CircularProgress color="secondary"/>:'Next'}
              </Button>
            </Box>
          </Box>
        )}
      </Box>

            </DialogContentText>
          </DialogContent>
          <DialogActions>
          
          <Button  className={classes.btn} onClick={()=>{
          setDialogStep(false);
          }} color="secondary" >
          Cancel
          </Button>

        </DialogActions>
</Dialog>



{/* dialog edit outlet  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={outletModify}
        
        aria-labelledby="edit_outlet"
        aria-describedby="edit_outlet"
      >
        <DialogTitle id="edit_outlet">Edit Outlet</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
             
               
  
              <Box display='flex' alignItems='center' justifyContent='center'>
               <TextField  value={oCode.value} size='small' variant='outlined' label={"Code"} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setOCode({value:"",error:"Enter code"})
                 }else{
                   setOCode({value:e.target.value,error:""});
                 }
               }} 
               error={oCode.error!==""}
               helperText={oCode.error}/>
              </Box>

              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
               <TextField value={outletName.value}  size='small' variant='outlined' label={"Name"} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setOutletName({value:"",error:"Enter name"})
                 }else{
                   setOutletName({value:e.target.value,error:""});
                 }
               }} 
               error={outletName.error!==""}
               helperText={outletName.error}/>
              </Box>




              <Box mt={1}  display='flex' alignItems='center' justifyContent='center'>
               <TextField  value={coordinates.value} size='small' variant='outlined' label={"Coordinates"} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setCoordinates({value:"",error:"Enter coordinates"})
                 }else{
                   setCoordinates({value:e.target.value,error:""});
                 }
               }} 
               error={coordinates.error!==""}
               helperText={coordinates.error}/>
              </Box>

              <Box mt={1}  display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="location">Select province</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select level"
        inputProps={{
          name: 'level',
          id: 'level',
        }}
        error={provinceId.error!==""}
        onChange={(e)=>{
          if(e.target.value===""){
            setProvinceId({value:"",error:"Select province"});
          }else{
            setProvinceId({value:e.target.value,error:""});
            FilterDistrict(e.target.value);
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {
            provinces.map((p)=>{
            return <MenuItem value={p['id']}>{p['name']}</MenuItem>
            })
          }
        </Select>
        <FormHelperText error={provinceId.error!==""}>{provinceId.error}</FormHelperText>
      </FormControl>
</Box>




<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="district">Choose district</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select district"
        inputProps={{
          name: 'disctrict',
          id: 'district',
        }}

        error={location.error!==""}
        onChange={(e)=>{
          if(e.target.value===""){
            setLocation({value:0,error:"Select district"});
          }else{
            setLocation({value:e.target.value,error:""});
            console.log(e.target.value);
          }
        }}
        
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          { 
            filterDistrict.map((d)=>{
                return <MenuItem value={d['id']}>{d['name']}</MenuItem>;
              }
            )
          }
        </Select>
        <FormControl error={location.error!==""}>{location.error}</FormControl>
      </FormControl>


</Box>





<Box mt={1}>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

<TextField  value={odescription.value}  size="small" rowsMax={10} rows={10} variant='outlined' label={<Translate id="operator_route.from_new_route.description" />}   color='primary'  fullWidth multiline 
onChange={(e)=>{
if(e.target.value===""){
  setODescription({value:"",error:"Enter description"});
}else{
  setODescription({value:e.target.value,error:""});
}
}}
/>
 </FormControl>
</Box>
                  
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
             setOutletModify(false);
          }} color="secondary" variant="outlined"  className={classes.btn}>
          <Typography><Translate id="operator_branch.form_new_branch.cancel" /></Typography>
          </Button>
          <Button disableElevation onClick={()=>{
           modify_outlet();
          }} variant="contained" color="primary" className={classes.btn} autoFocus>
            {modifyLoad?<CircularProgress size={20} color="secondary" />:<Typography><Translate id="operator_branch.form_new_branch.save" /></Typography>}
            
          </Button>
        </DialogActions>
      </Dialog>



{/* assign route to outlet  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={assignDialog}
      
        aria-labelledby="add_outlet"
        aria-describedby="add_outlet"
      >
        <DialogTitle id="add_outlet">Add route to outlet</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
             
               
  
              <Box display='flex' alignItems='center' justifyContent='center'>
               
              <Autocomplete
size="small"
      options={routes}
      getOptionLabel={(option) => option.name}
      fullWidth
      onChange={(event, newValue) => {
       
        if(newValue==null){
          setRouteId({value:0,error:""});
        }else{
          setRouteId({value:newValue.id,error:""});
        }
      }}
      renderInput={(params) => <TextField {...params} label="Select route" variant="outlined" />}

    />
              </Box>
                 
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
            setAssignDialog(false);
          }} color="secondary" variant="outlined"  className={classes.btn}>
          <Typography><Translate id="operator_branch.form_new_branch.cancel" /></Typography>
          </Button>
          <Button disableElevation onClick={()=>{
            assign_route();
          }} variant="contained" color="primary" className={classes.btn} autoFocus>
            {assignLoad?<CircularProgress size={20} color="secondary" />:<Typography><Translate id="operator_branch.form_new_branch.save" /></Typography>}
            
          </Button>
        </DialogActions>
      </Dialog>


{/* branch outlet dialog  */}


<Dialog 
fullScreen 
open={outletDialog} 

TransitionComponent={Transition}>
        <AppBar color="primary" className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={()=>{
              setOutletDialog(false);
            }} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Outlets
            </Typography>
            <Button autoFocus color="inherit" onClick={()=>{
              setOutletDialog(false);
            }}>
              Close
            </Button>
          </Toolbar>
        </AppBar>
        <Box ml={1} mt={2} alignItems="right" justifyItems="right">
        <Button  
className={classes.btn}
size="medium"
startIcon={<Add/>} 
onClick={()=>{

// setAddOutletDialog(true);
setDialogStep(true);

}} 
variant="contained" 
color="primary"
disableElevation={true}>

{matches&&<Typography noWrap>New Outlet</Typography>}
</Button>
        </Box>
    
        <Box mt={1}>
        {outletLoad&&<LinearProgress />}
        <MUIDataTable
          title={outtletTitle}
          data={outlets}
          columns={columnsOutlets}
          options={optionsOutlet}
        />
        </Box>
      </Dialog>


{/* route outlet dialog  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={routeOutletDialog}
      
        aria-labelledby="routes"
        aria-describedby="routes"
      >
        <DialogTitle id="routes">{"Routes"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          {routeOutletLoad==true&&<LinearProgress color="primary"/>}
          {routeOutletLoad==false&&routeOutlet.length==0&&"No route available in this outlet"}
          <List>

            {routeOutletLoad==false&&
            routeOutlet.map((r)=>{
              return <ListItem>
              <ListItemIcon>
                <EmojiTransportation />
              </ListItemIcon>
              <ListItemText
                primary={r['name']}
              />
            </ListItem>
            })
            }
               
            </List>
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={()=>{
            setRouteOutletDialog(false);
          }} color="secondary" variant="outlined" >
            close
          </Button>
         
        </DialogActions>
      </Dialog>






    </div>
  );
}



export default withLocalize(Outlets);
